<template>
  <q-page padding>
    <PageHeader
      :backRoute="{ name: 'compras-necessidades' }"
      backBehavior="route"
    >
      <template #title>
        Necessidade de compra ALMOX #{{ dados?.numero }}
      </template>
    </PageHeader>

    <div class="q-ml-md">
      <section class="column text-brand-5 text-weight-bold">
        <span
          style="font-size: 12px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          Numero da SC:
          <span style="font-size: 16px" class="q-ml-sm text-brand-1">
            <span>{{ dados?.cod_integracao }}</span>
          </span>
        </span>
        <span
          style="font-size: 12px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          Criado por:
          <span style="font-size: 16px" class="q-ml-sm text-brand-1">
            <span>{{ dados?.usuario_nome }}</span>
          </span>
        </span>
        <span
          style="font-size: 12px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          Urgência Definida:
          <span style="font-size: 16px" class="q-ml-sm text-brand-1">
            <span>{{ dados.tag }}</span>
          </span>
        </span>
        <span
          style="font-size: 12px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          Solicitante:
          <span style="font-size: 16px" class="q-ml-sm text-brand-1">
            <span>{{ dados.solicitante_nome }}</span>
          </span>
        </span>
        <span
          style="font-size: 12px"
          v-if="dados.cricao_necessidade"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          Criada Em:
          <span style="font-size: 16px" class="q-ml-sm text-brand-1">
            <span>{{
              dados.cricao_necessidade
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </span>
        </span>
      </section>
    </div>

    <div class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span> Produtos sem referência no catálogo </span>

        <q-btn
          @click="exportar"
          class="q-ml-sm"
          icon="file_upload"
          label="Exportar"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
        />
      </div>
      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="rows"
        dense
        :columns="columns"
        :loading="disable"
        class="tabela-tamanho-fixo"
        hide-pagination
        v-model:pagination="pagination"
        row-key="uuid"
        :rows-per-page-options="[0]"
        v-model:expanded="expanded"
      >
        <template v-slot:header="props">
          <q-tr style="background-color: #d9effc" :props="props">
            <q-th auto-width />

            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td auto-width>
              <q-toggle
                v-model="props.expand"
                checked-icon="add"
                unchecked-icon="remove"
              />
            </q-td>

            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.value }}
            </q-td>
          </q-tr>

          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <div class="column text-left">
                <span class="text-bold">Compras desse item:</span>
                <div
                  v-for="(compras, index) in props.row.compras"
                  :key="index"
                  class="row q-ml-md q-mt-sm"
                >
                  <span>QTD: {{ compras.quantidade }}</span
                  >/
                  <span class="q-ml-sm"
                    >Vlr: R${{ Number(compras.preco).toFixed(2) }}</span
                  >
                  /
                  <span class="q-ml-sm" v-if="compras.createdAt">
                    Em:
                    {{
                      compras.createdAt
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  ><span class="q-ml-sm" v-if="compras.createdAt">{{
                    compras.createdAt.split(" ")[1]
                  }}</span>
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>

        <template #body-cell-solicitante_nome="props">
          <q-td>
            <div class="row">
              <span>
                {{ props.row.solicitante_nome }}
              </span>
              <span> ( {{ props.row.solicitante_matricula }}) </span>
            </div>
          </q-td>
        </template>
        <template #body-cell-centroCusto="props">
          <q-td>
            <div class="row no-wrap">
              <span>
                {{ props.row.centroCusto.codigo }}
              </span>
              <span class="q-ml-sm"> ({{ props.row.centroCusto.nome }}) </span>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>

    <div class="row col-12 q-mt-lg q-ml-md">
      <div
        style="font-size: 16px"
        class="q-mb-sm text-brand-1 text-weight-medium"
      >
        <span> Arquivos da Necessidade.</span>
      </div>
      <div class="row col-12 q-gutter-sm items-center">
        <div class="col-4">
          <q-file label="Selecione o Arquivo" outlined dense v-model="file">
            <template v-slot:prepend>
              <q-icon name="attach_file" />
            </template>
          </q-file>
        </div>
        <div>
          <q-btn
            style="border-radius: 8px; background-color: #21324a; color: white"
            icon="done"
            no-caps
            label="Enviar Template"
            @click="enviarTemplate"
          />
        </div>
        <div>
          <q-btn
            icon="sym_o_add_box"
            style="border-radius: 8px; background-color: #304f78; color: white"
            no-caps
            label="Ver Produtos"
            @click="getDocumentos"
          />
        </div>
      </div>
    </div>

    <q-dialog v-model="documentos">
      <q-card style="width: 800px; max-width: 80vw; height: 80%">
        <q-card-section class="row justify-center">
          <div class="text-h6 text-brand-1 text-weight-bold">
            Documentos Enviados
          </div>
        </q-card-section>
        <q-separator />
        <ul class="col-12">
          <li
            class="text-brand-5"
            v-for="(documento, index) in listaDocumentos"
            :key="index"
          >
            <div class="row col-12 justify-between items-center q-mx-md">
              <div class="text-brand-1 text-weight-bold">
                {{ `Documento ${index + 1}` }}
              </div>
              <div>
                <q-btn
                  :href="documento.url"
                  round
                  flat
                  icon="sym_o_download"
                  style="color: #21324a"
                >
                </q-btn>
                <q-btn
                  dense
                  no-caps
                  flat
                  round
                  icon="sym_o_delete"
                  color="negative"
                  @click="deletarDocumento(documento.uuid)"
                ></q-btn>
              </div>
            </div>
          </li>
        </ul>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "centroCusto",
    label: "Unid. Controle",
    field: (row) =>
      row.centroCusto && row.centroCusto.nome
        ? row.centroCusto.codigo + " - " + row.centroCusto.nome
        : "Sem centro",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "usuario_nome",
    label: "Responsavel",
    field: (row) => row.responsavel.nome,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "product_codigo",
    label: "Produto",
    field: (row) => row.produto.nome,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "produto_nome",
    label: "Qtd. de Compra",
    field: (row) => row.quantidadeNecessaria,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
];

import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: {
    PageHeader,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const documentos = ref(false);
    const file = ref("");
    const disable = ref(true);
    const id = route.params.id;
    const dados = ref("");
    const listaDocumentos = ref([]);

    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/acompanhar", {
          uuid: id,
        });

        dados.value = response.data.data[0];
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const exportar = async () => {
      try {
        await store.dispatch("compras/exportarAcompanhar", {
          vendor_id: store.state.org.unidadeData.id,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarTemplate = async () => {
      if (file.value == "") {
        $q.notify({
          message: "O campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            await store.dispatch("compras/uploadAcompanhar", {
              arquivo: reader.result,
              uuid: id,
            });

            $q.notify({
              message: "Enviado com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            getDados();
          } catch (error) {
            $q.notify({
              message: "Erro a o enviar",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        };

        file.value = "";
      } catch (error) {
        console.log(error);

        file.value = "";
      }
    };

    const getDocumentos = async () => {
      documentos.value = true;
      try {
        let response = await store.dispatch("compras/getArquivosAcompanhar", {
          uuid: id,
        });

        listaDocumentos.value = response.data.result.data;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar documentos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getDetalhes = async () => {
      try {
        const response = await store.dispatch("compras/historicoNecessidade", {
          uuid: id,
        });
        rows.value = response.data.necessidade.itens;

        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDetalhes);

    return {
      dados,
      getDados,
      columns,
      rows,
      disable,

      exportar,
      file,
      enviarTemplate,
      getDocumentos,
      documentos,
      listaDocumentos,
      expanded: ref([
        // Array of row keys
      ]),
      getDetalhes,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
tbody tr td {
  white-space: pre-wrap;
}
a {
  text-decoration: none;
}
.align {
  align-items: center;
}

.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
